import { CurrencySelect, UpsellGuard } from '@components'

import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { Scope } from '../../../../../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../../../../../enums/trackingContext'
import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultCurrency = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      label={t('settings.organization.external_invoice.general.default_currency.label')}
      name="currency"
      render={({ field: { value, onChange, ...rest } }) => (
        <UpsellGuard scope={Scope.InvoiceMultiCurrencyUpsell} trackingContext={TrackingContext.InvoiceMultiCurrency}>
          <CurrencySelect
            {...rest}
            dropdownSize="fitTrigger"
            onSelect={(currency) => {
              onChange(currency)
              trackInvoicingSettings('Currency dropdown selected', { currency })
            }}
            prefix={<Icon icon="coins" />}
            selectedId={value}
          />
        </UpsellGuard>
      )}
    />
  )
}
